<template>
    <v-container fluid style="max-width: 500px;"> 
         <ModuleDialog ref="module" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <EditDialog ref="dialog_editor" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <ExternalDocumentCategoryDialog ref="external_document_category" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <AuditLogDialog ref="audit_log" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <AdminConfigurationDialog ref="sys_config" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <SupportTicketDialog ref="support_ticket" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <ExportDialog ref="export" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <ActivityTypeDialog ref="activity_type" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <DepartmentDialog ref="departments" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <MessageDialog ref="message" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <DocumentCategoryDialog ref="document_category" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <WebhooksDialog ref="webhooks" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <DBDialog ref="dialog_builder" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <CopyCalendarExerciseDialog ref="copy_calendar_exercise" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <CopyCalendarRulesDialog ref="copy_calendar_rules" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <ComplaintDialog ref="complaint" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <ResponseMessageDialog ref="response_message" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <TeleworkDialog ref="telework" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <ExpenseSheetDetailDialog ref="expense_sheet_detail" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <WorkplaceDialog ref="workplace" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <HolidaysTableDialog ref="holidays" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <CreateTeamDialog ref="create_team" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <EditTeamDialog ref="edit_team" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <CreateProjectDialog ref="create_project" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <EditProjectDialog ref="edit_project" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <ReleaseEditorDialog ref="release" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <ProfilesDialog ref="profiles" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <PartnersDialog ref="partners" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <NewsDialog ref="news" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <AiAssistantDialog ref="ai_assistant_log" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>
         <PaidAbsencesCategoryDialog ref="paid_absences_category" v-on:show-alert="(payload) => doShowAlert(payload)" v-on:refresh="$emit('refresh')"/>

         <v-snackbar
            v-model="showAlert"
            :timeout="alertTimeout"
            :color="alertColor">
                <span style="color: #ffffff;">{{alertText}}</span>
                <v-btn text @click="showAlert=false">
                <span style="color: #ffffff;">{{$t('wkt.admin.common.dialog-buttons.close')}}</span>
                </v-btn>
            </v-snackbar>
     </v-container>
 </template>
 
 <script> 
 
 import ModuleDialog from "./dialogs/ModuleDialog";
 import EditDialog from "./db/EditDialog";
 import ExternalDocumentCategoryDialog from "./dialogs/ExternalDocumentCategoryDialog";
 import AuditLogDialog from "./dialogs/AuditLogDialog";
 import AdminConfigurationDialog from "./dialogs/AdminConfigurationDialog.vue";
 import SupportTicketDialog from "./dialogs/SupportTicketDialog";
 import ExportDialog from "./dialogs/ExportDialog";
 import ActivityTypeDialog from "./dialogs/ActivityTypeDialog.vue"
 import DepartmentDialog from './dialogs/DepartmentDialog';
 import MessageDialog from "./dialogs/MessageDialog";
 import DocumentCategoryDialog from './dialogs/DocumentCategoryDialog.vue';
 import WebhooksDialog from './dialogs/WebhooksDialog.vue'
 import DBDialog from "./db/DBDialog";
 import CopyCalendarExerciseDialog from "./dialogs/CopyCalendarExerciseDialog";
 import CopyCalendarRulesDialog from "./dialogs/CopyCalendarRulesDialog";
 import ComplaintDialog from "./dialogs/ComplaintDialog";
 import ResponseMessageDialog from "./dialogs/ResponseMessageDialog.vue"
 import TeleworkDialog from "./dialogs/TeleworkDialog.vue";
 import ExpenseSheetDetailDialog from "./dialogs/ExpenseSheetDetailDialog";
 import WorkplaceDialog from "./dialogs/WorkplaceDialog.vue";
 import HolidaysTableDialog from "./dialogs/HolidaysTableDialog.vue";
 import CreateTeamDialog from "./dialogs/CreateTeamDialog.vue";
 import EditTeamDialog from "./dialogs/EditTeamDialog.vue";
 import CreateProjectDialog from "./dialogs/CreateProjectDialog.vue";
 import EditProjectDialog from "./dialogs/EditProjectDialog.vue";
 import ReleaseEditorDialog from "./dialogs/ReleaseEditorDialog.vue";
 import ProfilesDialog from "./dialogs/ProfilesDialog.vue";
 import PartnersDialog from './dialogs/PartnersDialog.vue'
 import NewsDialog from "./dialogs/NewsDialog.vue"
 import AiAssistantDialog from "./dialogs/AiAssistantDialog.vue"
 import PaidAbsencesCategoryDialog from "./dialogs/PaidAbsencesCategoryDialog.vue";

 export default {
   name: 'DialogManager',
   components: { 
    ModuleDialog, ExternalDocumentCategoryDialog, AuditLogDialog, AdminConfigurationDialog, SupportTicketDialog, ExportDialog,MessageDialog,
      DocumentCategoryDialog, DBDialog, CopyCalendarExerciseDialog, CopyCalendarRulesDialog, ComplaintDialog, EditDialog, DepartmentDialog, 
      WebhooksDialog, TeleworkDialog, ActivityTypeDialog, ExpenseSheetDetailDialog, WorkplaceDialog, HolidaysTableDialog, CreateTeamDialog, EditTeamDialog, CreateProjectDialog, 
      EditProjectDialog, ResponseMessageDialog, ReleaseEditorDialog, ProfilesDialog, PartnersDialog, NewsDialog, AiAssistantDialog, PaidAbsencesCategoryDialog
   },
   
   data() {
       return {
                showAlert: false,
				alertColor: 'error',
				alertText: '',
				alertTimeout: 3000
       }
   },
    methods: {
    // eslint-disable-next-line no-unused-vars
     processEvent(mode, type, action, payload, eventConfig) {
        this.$refs[type.toLowerCase()].open(action, payload, eventConfig);
     },
     doShowAlert (payload) {
			this.alertText = payload.text;
			this.alertColor = payload.color;
			this.alertTimeout = payload.timeout;
			this.showAlert = true;
     },
    }
 };
 </script>
 